// Representative sample stills (stock photos) shown as model previews in the picker.
const POOL = {
  portrait: [
    "https://images.unsplash.com/photo-1508179522353-11ba468c4a1c",
    "https://images.unsplash.com/photo-1533461502717-83546f485d24",
    "https://images.unsplash.com/photo-1500305614571-ae5b6592e65d",
    "https://images.unsplash.com/photo-1725288453683-3d3a6ec420ec",
  ],
  landscape: [
    "https://images.unsplash.com/photo-1665314673834-635d0fedab32",
    "https://images.unsplash.com/photo-1534196213718-bd643e406be4",
    "https://images.unsplash.com/photo-1665314673849-299218d228f1",
  ],
  city: [
    "https://images.unsplash.com/photo-1576514864427-f0809d2b66eb",
    "https://images.unsplash.com/photo-1642019341061-f81d61659c62",
    "https://images.unsplash.com/photo-1516900557549-41557d405adf",
  ],
  motion: [
    "https://images.unsplash.com/photo-1529229504105-4ea795dcbf59",
    "https://images.unsplash.com/photo-1633872908246-8525af262f76",
    "https://images.unsplash.com/photo-1511715282680-fbf93a50e721",
  ],
  design: [
    "https://images.unsplash.com/photo-1738003667850-a2fb736e31b3",
    "https://images.unsplash.com/photo-1595142545813-06fee27f3dcb",
  ],
  studio: [
    "https://images.unsplash.com/photo-1545242640-7c9e9cc07d23",
    "https://images.unsplash.com/photo-1682078234868-412ec5566118",
  ],
};

const THEME = { sparkles: "portrait", banana: "studio", flower: "portrait", pen: "design", type: "design", zap: "city",
  wand: "studio", mountain: "landscape", rocket: "city", film: "city", clapper: "landscape", waves: "landscape", globe: "landscape",
  maximize: "city", mic: "portrait", user: "portrait", move: "motion", shuffle: "motion", audio: "portrait", languages: "portrait" };

const hash = (s) => [...s].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7);

export const sampleFor = (m) => {
  const list = POOL[THEME[m?.icon] || "portrait"];
  return `${list[hash(m?.id || "") % list.length]}?auto=format&fit=crop&w=560&h=320&q=70`;
};
